import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Paper, makeStyles, IconButton, TableBody, TableRow, TableCell, CircularProgress, Tooltip, Button } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import useTable from '../useTable';
import GetAppIcon from '@material-ui/icons/GetApp';
import { dateFormatter, sleep } from '../Models/CommonFunc';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { useParams } from 'react-router-dom';
import PurchaseListFilters from './PurchaseListFilters';
import { getDownloadUrlFromFullPath } from '../../Backend/firebase/user';
import Popup from '../Popup';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import CustomAlert from '../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import draftToHtml from 'draftjs-to-html';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Helmet } from 'react-helmet';
import { getAllAppliedProductsByProductIdAsync } from '../../Backend/firebase/product';
import db from '../../Backend/firebase/firebase';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'ProductName', label: 'My Product Name', disableSorting: false },
    { id: 'customerEmail', label: 'Email', disableSorting: true },
    { id: 'customerMobile', label: 'Mobile', disableSorting: true },
    { id: 'createAt', label: 'Purchase on', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function PurchaseList() {
    const { id } = useParams();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [records, setRecords] = useState([]);
    const [product, setProduct] = useState(null);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn);
    const [openPopup, setOpenPopup] = useState(false);
    const { register, handleSubmit, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [uniqueIdForUpdate, setUniqueIdForUpdate] = useState(null);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [downloadHtml, setDownloadHtml] = useState(null);

    useEffect(async () => {
        if (id) {
            try {
                const getApplicant = await getAllAppliedProductsByProductIdAsync(id);
                headCells.forEach((val) => {
                    if (val.id === 'ProductName') {
                        val.label = getApplicant.product.ProductName;
                    }
                });
                setRecords(getApplicant.appliedApplicant);
                setProduct(getApplicant.product);
            } catch(error) {
                console.log("Product Application Error Occur in Get All Applied Products", error)
            }
            // await server.get(`/Product/GetAllAppliedProductsByProductIdAsync/${id}`)
            //     .then((response) => {
            //         if (response.status === 200 && response.data.message === 'success') {
            //             setRecords(response.data.data.appliedApplicant);
            //             setProduct(response.data.data.product);
            //         }
            //     }).catch(err => console.log(err.message));
        }
    }, [id]);

    useEffect(() => {
        if (product) {
            headCells.forEach((val) => {
                if (val.id === 'ProductName') {
                    val.label = product.ProductName;
                }
            });
        }
    }, [product]);

    const handleSearch = (e) => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.name.toLowerCase().includes(target.value));
                }
            }
        });
    };

    const handleFilters = async (filter) => {
        console.log("filter",filter)
        // await server.post(`/Product/GetFilteredAllAppliedProductsByProductIdAsync/${id}`, filter)
        //     .then((response) => {
        //         if (response.status === 200 && response.data.message === 'success') {
        //             setRecords(response.data.data.appliedApplicant);
        //             setProduct(response.data.data.product);
        //         }
        //     }).catch(err => console.log(err));
    };

    const downloadCV = async (path) => {
        var url = await getDownloadUrlFromFullPath(path);
        const newWindow = window.open();
        newWindow.location.href = url;
    };

    const OpenUpdateOption = (uniqueId) => {
        setUniqueIdForUpdate(uniqueId);
        setOpenPopup(true)
    };

    const updateApplicationStatus = async (data) => {
        setIsLoading(true);
        var model = {
            uniqueId: uniqueIdForUpdate,
            applicationStatus: data.applicationStatus,
            rejectedReason: data.rejectedReason
        };

        try {
            const docRef = db.doc(`/AppliedProducts/${uniqueIdForUpdate}`);
            await docRef.update(model).then(docRef => {
                console.log("A New Document Field has been added to an existing document");
                setNotificationMessage("Application Status Updated Sucessfullly!");
                setOpenNotify(true);
                setAlertType('success');
                setIsLoading(false);
                setTimeout(reloadPage, 2000);
            })
            .catch(error => {
                console.log(error);
                console.log("Error Occur in Update Product Status ", error)
                setNotificationMessage("Something went wrong, Please try again later!");
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
            })
        } catch(error) {
            console.log("Error Occur in Update Product Status ", error)
            setNotificationMessage("Something went wrong, Please try again later!");
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
        }
        // await server.put('/Product/UpdateAppliedProductStatusAsync', model)
        //     .then((resp) => {
        //         if (resp.status === 200 && resp.data.message === 'success') {
        //             setNotificationMessage(resp.data.data);
        //             setOpenNotify(true);
        //             setAlertType('success');
        //             setIsLoading(false);
        //             setTimeout(reloadPage, 2000);
        //         } else {
        //             setNotificationMessage(resp.data.data);
        //             setOpenNotify(true);
        //             setAlertType('error');
        //             setIsLoading(false);
        //         }
        //     }).catch(err => console.log(err.message));
    };

    const reloadPage = () => {
        window.location.reload(true);
    }

    return (
        <>
            <div className="allProducts">
                <Paper className={fixedHeightPaper}>
                    {records && product ?
                        <div className="row d-flex justify-content-center w-100 align-items-center">
                            <Helmet>
                                <meta name="description" content="Find all applicants who are applied on your posted products." />
                                <title>Applicant List | {product.ProductName}</title>
                            </Helmet>
                            <div className="col-md-8">
                                <PurchaseListFilters handleFilters={handleFilters} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search products" className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TblContainer>
                                    <TblHead />
                                    {recordsAfterPagingAndSorting().length <= 0 && product === null ? 'No applicant found.' :
                                        <TableBody>
                                            {
                                                recordsAfterPagingAndSorting().map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{item?.applicantName}</TableCell>
                                                        <TableCell>{item?.customerEmail}</TableCell>
                                                        <TableCell>{item?.customerMobile}</TableCell>
                                                        <TableCell>{dateFormatter(item?.productAppliedDateTime.toDate().toString())}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Update Application Status" placement="top">
                                                                <IconButton color="primary"
                                                                    onClick={() => OpenUpdateOption(item?.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    }
                                </TblContainer>
                                <TblPagination />
                            </div>
                        </div>
                        : <div className="row mt-3">
                            <div className="col-md-12 text-center p-4">
                                <CircularProgress />
                            </div>
                            <div className="col-md-12 text-center mt-2">
                                <h5>No Purchase found, still waiting for new Purchase!</h5>
                            </div>
                        </div>}

                    <div className="row mt-5" style={{ display: 'none' }}>
                        <div className="col-md-12">
                            <div id="downloadContent"
                                dangerouslySetInnerHTML={{ __html: draftToHtml(downloadHtml) }} />
                        </div>
                    </div>
                </Paper>
            </div>

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Application Status" popupSize="xs">
                <form onSubmit={handleSubmit(updateApplicationStatus)}>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Application Status</label>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.applicationStatus })} aria-label="Default select example"
                                    name="applicationStatus" ref={register({
                                        required: 'Please select any status!',
                                        validate: {
                                            defaultValue: value => value !== "Select Status" || 'Please select any status!'
                                        }
                                    })} defaultValue="Select Status">
                                    <option value="Select Status">Select Status</option>
                                    <option value="New">New</option>
                                    <option value="ShortListed">ShortListed</option>
                                    <option value="Selected">Selected</option>
                                    <option value="Rejected">Rejected</option>
                                </select>
                                <small className="form-text text-danger">{errors.applicationStatus && errors.applicationStatus.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-2">
                            <div className="form-group">
                                <label className="login__textboxLabel">Reject Reason, If you are rejecting this candidate (Optional)</label>
                                <textarea type="text" className="form-control registerEmp__textbox"
                                    name="rejectedReason" placeholder="Reject reason" autoComplete="none"
                                    ref={register}></textarea>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <Alert severity="info">
                                <AlertTitle>Note!</AlertTitle>
                                You are changing status of candidate application. You have to contact candidate yourself. The application
                                will not send email on your behalf.
                            </Alert>
                        </div>
                        <div className="col-md-12 text-center mt-4 mb-4">
                            <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                {isLoading ? <CircularProgress size={18} /> : 'Submit'}
                            </Button>
                        </div>
                    </div>
                </form>
            </Popup>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default PurchaseList
